import type { VenueDetailCourtsComponent, CourtItem } from '../../../types/sdui-arena-detail'
import { CourtsSection } from '../../CourtsSection'
import type { Court } from '../../../types/arena'

interface VenueDetailCourtsProps {
  config: VenueDetailCourtsComponent
}

export function VenueDetailCourts({ config }: VenueDetailCourtsProps) {
  const { courts } = config

  // Convert to CourtsSection format
  const formattedCourts: Court[] = courts.map(c => ({
    id: c.id,
    name: c.name,
    modalities: c.modalities,
    surface: c.surface,
    lighting: c.lighting,
    covered: c.covered,
    capacity: c.capacity,
    pricePerHour: c.pricePerHour
  }))

  return <CourtsSection courts={formattedCourts} />
}
